
(() => {
  const sleep = ms => new Promise(resolve => setTimeout(resolve, ms));

  const replaceElement = (oldElement, newElement, settings={}) => {
    if (typeof newElement === 'string') {
      const div = document.createElement('div');
      div.innerHTML = newElement;
      newElement = div;
    }

    if (settings.hasParentAttributes) {
      const attrs = [...oldElement.attributes];
      attrs.forEach(({nodeName: k, nodeValue: v}) => newElement.setAttribute(k, v));
    }

    if (settings.hasParentInnerHTML) {
      newElement.innerHTML = oldElement.innerHTML;
    }

    oldElement.parentNode.insertBefore(newElement, oldElement.nextSibling);
    oldElement.remove();
  };

  const otherUserMarker = () => {
    const snippet = document.querySelector('.description-snippet');
    const links = [...snippet.querySelectorAll('a')];
    links.forEach(l => {
      const img = l.querySelector('img');
      if (!img || !img.src || !img.getAttribute('data-src')) return;
      const emptyImg = 'data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==';
      const src = img.src && img.src !== emptyImg ? img.src : img.getAttribute('data-src');
      const isMini = src.toLowerCase().includes('mini-') || src.toLowerCase().includes('tlm-');
      if (!isMini) return;

      l.classList.add('other-use-link');
    });
  };
  otherUserMarker();


  const replaceUTags = () => {
    const us = [...document.querySelectorAll('u')];
    if (!us) return;
    us.forEach(u => {
      const span = document.createElement('span');
      span.innerHTML = u.innerHTML;
      replaceElement(u, span);
    });
  };
  replaceUTags();

  const setupNortonBtn = () => {
    const nortonBtn = document.querySelector('.norton-btn');
    if (!nortonBtn) return;
    nortonBtn.addEventListener('click', () => {
      if (location.href.includes('shopifypreview')) {
        alert('Normally this button would trigger a Norton popup. Norton uses domain validation so this can\'t happen on the preview site.');
        return;
      }

      const nortonBadge = document.querySelector('#buysafeseal_1_a');
      nortonBadge.click();
    });
  };
  setupNortonBtn();

  const listElementFixer = () => {
    const desc = document.querySelector('.product-desc-tab');
    const lis = [...desc.querySelectorAll('li')];
    for (const li of lis) {
      const ps = li.previousElementSibling;
      if (li.parentNode.tagName === 'UL') continue;
      if (li.previousElementSibling.tagName === 'UL') {
        ps.appendChild(li);
        continue;
      }

      const ul = document.createElement('ul');
      li.parentNode.insertBefore(ul, li.nextSibling);
      ul.appendChild(li);
    }
  };
  listElementFixer();

  const headerFixer = () => {
    const headers = [...document.querySelectorAll('h1, h2, h3, h4, h5, h6')];
    for (const header of headers) {
      if (!header.innerHTML.includes('Other Uses for ')) continue;
      const h5 = document.createElement('h5');
      replaceElement(header, h5, {hasParentInnerHTML: true});
    }
  };
  headerFixer();

  const pdfLinkFixer = () => {
    const snippet = document.querySelector('.description-snippet'); 
    const links = [...snippet.querySelectorAll('a')];
    for (const link of links) {
      const comp = link.innerHTML.toLowerCase();
      const keywords = ['download', 'pdf', 'read', 'growing guide'];
    }
  };
  pdfLinkFixer();

  const pdfLinkDescAdder = () => {
    const desc = document.querySelector('.product-desc-tab');
    const links = [...desc.querySelectorAll('a')];
    for (const link of links) {
      const isPDF = link.innerHTML.toLowerCase().includes('pdf');
      if (!isPDF) continue;
      const svg = document.createElement('img');
      const size = 40;
      const url = document.querySelector('#icon-pdf-link').innerHTML;
      svg.src = url;

      const svgWrapper = document.createElement('a');
      svgWrapper.href = link.href;
      svgWrapper.classList.add('pdf-download-link');
      svgWrapper.innerHTML = svg.outerHTML;

      link.insertAdjacentElement('afterend', svgWrapper);
    }
  };
  pdfLinkDescAdder();

  const convertToGrams = (value, fromUnit) => {
    const gramsPounds = 453.59;
    const gramsOunce = 28.3;
    const unitsInGrams = {
      'g': 1,
      'oz': gramsOunce,
      'ounce': gramsOunce,
      'lb': gramsPounds,
      'pound': gramsPounds,
    };

    const c = v => v.slice(-1) === 's' ? v.slice(0, -1) : v;
    const gramValue = unitsInGrams[c(fromUnit)];

    return gramValue * value;
  };

  const getSeedsPerPackage = () => {
    const perPackage = [];
    const patt = /([\d,]+) ?(.+) (?:.+)Approximately ([\d,]+)(?:.+)eeds/;

    const description = '.product-desc-tab'.select();
    const descContent = description.innerHTML.toLowerCase();
    if (!descContent.includes('seeds per package')) return;

    const lis = 'li'.selectAll();
    for (const li of lis) {
      const content = li.innerHTML;
      const match = content.match(patt);
      if (!match) continue;
      const [_, rawUnitCount, rawUnitLabel, rawSeedsCount] = match;
      const [unitCount, seedsCount] = [rawUnitCount, rawSeedsCount].map(v => v.toInt());
      const unitLabel = rawUnitLabel.lower().trim();

      perPackage.push({
        grams: convertToGrams(unitCount, unitLabel, 'g'),
        seedCount: seedsCount,
        unit: `${unitCount} ${unitLabel}`,
        originalUnit: unitLabel,
        unitValue: unitCount
      });
    }

    consell.log(perPackage);
    return perPackage;
  };
  getSeedsPerPackage();

  const attributeLinkFixer = async () => {
    await sleep(100);
    const link = document.querySelector('.attributes-toggle');
    const attrs = document.querySelector('#product-attributes');
    consell.log(link, attrs);
    if (!link || !attrs) return;
    link.addEventListener('click', () => {
      consell.log('golly');
      const {scrollTop} = attrs;
      window.scrollTo(scrollTop);
    })
  };
  attributeLinkFixer();


  const emailOutOfStockFixer = async () => {
    await sleep(100);
    const istock = document.querySelector('.iStock-wrapper');
    if (!istock) return;

    //add-cart-btn
    const cartBtn = document.querySelector('.add-cart-btn');
    if (!cartBtn) return;

    const isOutOfStock = cartBtn.innerText.toUpperCase() === 'SOLD OUT';
    if (!isOutOfStock) return;

    istock.style.display = 'block';
    const controlsRow = document.querySelector('.product-form__item.product-controls-row');
    controlsRow.insertAdjacentElement('afterend', istock);

    const gutter = document.querySelector('.product-form.product-form-product-template > .gutter-ele-bottom.gutter-ele-bottom-tbs');
    if (gutter) gutter.remove();
  };
  emailOutOfStockFixer();

  const attrScroller = () => {
    const tabC = document.querySelector('.product-tab-attributes'); 
    if (!tabC) return;
    const tab = tabC.parentElement;
    const attrs = document.querySelector('.accordian-type-attributes');
    if (!tab || !attrs) return;

    tab.addEventListener('click', () => {
      attrs.scrollIntoView();
    });
  };
  attrScroller();

  const addCartBtn = () => {
    const cartBtn = document.querySelector('.add-cart-btn');
    if (!cartBtn) return;
    cartBtn.addEventListener('click', () => {
      consell.log('hi!');
      const cartText = cartBtn.querySelector('span');
      cartText.innerHTML = 'Added!';
    })
  };

  document.addEventListener('add-to-cart', async event => {
    const cartBtn = document.querySelector('.add-cart-btn');
    await sleep(1000);

    const cartBtnContainer = document.querySelector('.cart-btn-container');
    const cartText = cartBtn.querySelector('span');

    if (!cartBtnContainer.querySelector('.added-to-cart-text')) {
      cartText.innerHTML = 'Added!';

      const addedText = document.createElement('span');
      addedText.classList.add('added-to-cart-text');
      addedText.innerHTML = /*html*/`Added to cart!&nbsp;&nbsp;<a class="go-to-checkout" href="/cart">Go to checkout.</a>`

      cartBtnContainer.appendChild(addedText);
    } else {
      const cartText = cartBtn.querySelector('span');
      cartText.innerHTML = 'Add to cart!';
      const addedText = cartBtnContainer.querySelector('.added-to-cart-text');
      addedText.remove();
    }


    const onVariantClick = event => {
      const addText = document.querySelector('.added-to-cart-text');
      if (addText) addText.remove();
    };

    const addVariantHandlers = () => {
      const variantBtns = [...document.querySelectorAll('.pg__option__value')];
      variantBtns.forEach(b => b.addEventListener('click', onVariantClick));
    };
    addVariantHandlers();
  });

  const iframeGame = () => {
    const isMobile = window.innerWidth < 1000;
    if (!isMobile) return;
    const a = (n, e) => e.getAttribute(n) && e.removeAttribute(n);

    const iframes = [...document.querySelectorAll('iframe')];
    for (const iframe of iframes) {
      ['width', 'height'].forEach(n => a(n, iframe));
    }
  };
  iframeGame();

  const accessibilityThing = () => {
    //Add accessibility info
    const emailField = document.querySelector('#iStock-email-id');
    if (!emailField) return;
    emailField.setAttribute('aria-label', 'Email');
  };

  setTimeout(accessibilityThing, 2000);
})();